/**
 * Debounce a function
 * @param { function } fn
 * @param { Number } wait
 * @returns { function }
 * @example
 * debounce(() => {
 *  // do something
 * }, 300);
 */
const debounce = (function_, wait) => {
  let t;
  return (...arguments_) => {
    clearTimeout(t);
    t = setTimeout(() => function_.apply(this, arguments_), wait);
  };
};

export { debounce };
